import React from "react";
import { NavLink, useLocation } from "react-router-dom";

import "./Sidebar.css";
import SidebarItems from "./SidebarItems";
import SidebarItem from "./SidebarItem";
import { usePermissionsContext } from "../context/contextPermissions";

const SideBar = (props) => {
  const { showMenu, mobileView } = props;
  const location = useLocation();
  const { permissions, setPermissions } = usePermissionsContext();

  return (
    <aside className={`sidebar ${mobileView ? "mobile__sidebar" : null}`}>
      <div className="sidebar__navigation">
        {SidebarItems.map((item) => {
          if (permissions.upload_panel == false && item.name == "Upload") {
            return;
          }
          if (permissions.admin_panel == false && item.name == "Admin") {
            return;
          } else {
            return (
              <NavLink
                to={item.route}
                key={item.name}
                exact
                activeClassName="active-menu"
                className={({ isActive }) => (isActive ? "active-menu" : "")}
              >
                <SidebarItem name={item.name}></SidebarItem>
              </NavLink>
            );
          }
        })}
      </div>
    </aside>
  );
};

export default SideBar;
